var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { getSpendingTrendsAnalyticsProps } from '../../../const/analytics/spending-trends';
import { StyledBaseButton } from '../../../styles/buttons';
import { StyledBackground, StyledBorder } from '../../../styles/common';
var SpendingTrendsBanner = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (_jsxs(_Fragment, { children: [_jsx(StyledBackground, { children: _jsx(Inset, { children: _jsxs(StyledBaseButton, __assign({ color: "cyanBlue", fontSize: "root", onClick: onClick }, getSpendingTrendsAnalyticsProps().banner, { children: [t('spendingTrends.bannerText'), ' ', _jsx(FontAwesomeIcon, { icon: faAngleRight, size: "lg" })] })) }) }), _jsx(StyledBorder, {})] }));
};
export default SpendingTrendsBanner;
//# sourceMappingURL=index.js.map